import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { io, Socket } from "socket.io-client";
import { environment } from "../../../../environments/environment";

interface ProgressData {
    processed: number;
    remaining: number;
    total: number;
    percentage: number;
}

@Injectable({
    providedIn: "root",
})
export class WebsocketService {
    private static socketInstance: Socket | null = null;
    private progressSubject = new Subject<ProgressData>();
    private importProgressSubject = new Subject<ProgressData>();
    private reportCompletionSubject = new Subject<string>();
    private importProductsCompletionSubject = new Subject<string>();
    private apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) {
        if (!WebsocketService.socketInstance) {
            WebsocketService.socketInstance = io(environment.socketUrl);
        }
        WebsocketService.socketInstance.on("connect", () => {
            console.log("WebSocket Connected!");
        });

        WebsocketService.socketInstance.on("disconnect", () => {
            console.log("WebSocket Disconnected!");
        });

        WebsocketService.socketInstance.on("connect_error", (err) => {
            console.error("WebSocket Connection Error:", err);
        });
    }

    private headers = new HttpHeaders({
        "Content-Type": "application/json",
        accept: "*/*",
    });

    getProductsUpdate(): Observable<any> {
        return new Observable((observer) => {
            WebsocketService.socketInstance?.on("productsProcessed", (data) => {
                observer.next(data);

                const total = data.products_processed + data.remaining_products;
                const percentage = Math.round((data.products_processed / total) * 100);

                if (percentage === 100) {
                    console.log("Report processing completed:", data.reportId);
                    this.reportCompletionSubject.next(data.reportId);
                }
            });
        });
    }
 
    getReportCompletionUpdates(): Observable<string> {
        return this.reportCompletionSubject.asObservable();
    }

    disconnectSocket() { }

    getGeneratedReports(limit: number, page: number): Observable<any> {
        return this.http.get<any[]>(`${this.apiUrl}reports/report-lit?limit=${limit}&page=${page}`, { headers: this.headers });
    }

    generateReports(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}reports/generate-report`);
    }

    getAllProducts(report: string, filters: any, searchText: string = "", page: number, limit: number) {
        const requestData = {
            filters: { ...filters },
            search: searchText,
            page,
            limit,
        };
        return this.http.post(`${this.apiUrl}reports/get-reportwise-products?report=${report}`, requestData);
    }

    getProductDetail(id: string) {
        return this.http.get(`${this.apiUrl}reports/product-report-by-id?report=${id}`);
    }

    getReportDetailByID(id: string) {
        return this.http.get(`${this.apiUrl}reports/get-report?id=${id}`);
    }
   
  downloadReport(reportId: string): Observable<Blob> {
    const url = `${this.apiUrl}reports/dowload-report?report=${encodeURIComponent(reportId)}`;
    const headers = new HttpHeaders({ 'Accept': '*/*' });

    return this.http.get(url, { headers, responseType: 'blob' });
  }
}
